import React, { useEffect, useRef } from 'react'
import { icons } from '@/shahrzad-assets/shared-asstes/icons'
import { colors, palette } from '@/shahrzad-assets/shared-constants/colors'
import { dimens } from '@/shahrzad-assets/shared-constants/dimens'
import { fontSize } from '@/shahrzad-assets/shared-constants/fonts'
import { sharedPathes } from '@/shahrzad-assets/shared-routing/pathe'
import { Col, Row } from 'antd'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { DEVICE } from '../shared-constants/breakPoints'

const Footer = () => {
  const baseLink =
    import.meta.env.PACKAGE_NAME == 'base-superapp'
      ? '/'
      : import.meta.env.VITE_MAIN_WEB_URL
  // Check if footer is visible
  const footerRef = useRef(null);
  useEffect(()=>{
    const observer = new IntersectionObserver((entries)=>{
      const entry = entries[0];
      localStorage.setItem('is_footer_visible', JSON.stringify(entry.isIntersecting));
      dispatchEvent(new Event('storage'))
    },{
      root: null,
      rootMargin: "0px",
      threshold: 0.3
    });
    if(footerRef.current) {
      observer.observe(footerRef.current);
    }
    return ()=> footerRef.current && observer.unobserve(footerRef.current);
  },[]);
  return (
    <FooterContainer ref={footerRef}>
      <ItemsRow justify='space-between'>
        <Col span={10}>
          <ImageContainer>
            <Link to={baseLink}>
              <img src={icons.LOGO_SHAHRZAD_MILAD} alt='shahrzad logo' />
            </Link>
          </ImageContainer>
        </Col>
        <LinksContainer span={14}>
          <ul>
            <Link to={baseLink + sharedPathes.ABOUT_SHAHRZAD}>
              <li>درباره شهرزاد</li>
            </Link>
            <Link to={baseLink + sharedPathes.PRIVACY}>
              <li>قوانین سایت</li>
            </Link>{' '}
            <a href={`tel:02196001375`}>
              <li> تماس با ما</li>
            </a>
            <Link to={baseLink + sharedPathes.FAQ}>
              <li>پرسش های متداول</li>
            </Link>
            <Link target='_blank' to={'https://shahrzaad.city/'}>
              <li> اپلیکیشن موبایل</li>
            </Link>
          </ul>
        </LinksContainer>
      </ItemsRow>
    </FooterContainer>
  )
}

export default Footer

const FooterContainer = styled.div`
  background-color: ${colors.primaryBrandBg4};
  bottom: 0;
  display: flex;
  height: auto;
  max-height: 500px;
  width: 100%;
  padding: ${dimens.SPACING_M} 7rem;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;

  @media ${DEVICE.laptop} {
    height: ${dimens.WEB_VIEW_FOOTER_HEIGHT};
  }
`
const ItemsRow = styled(Row)`
  width: 100%;
`
const LinksContainer = styled(Col)`
  display: flex;
  align-items: center;
  ul {
    display: flex;
    li {
      font-size: ${fontSize.SMALL};
      line-height: ${dimens.LINE_HEIGHT_NORMAL};
      padding: 0 ${dimens.SPACING_XL};
    }
  }
`
const ImageContainer = styled.div`
  img {
    height: 65px !important;
  }
`
